import { useMachine } from '@xstate/react';
import { useEffect, useMemo } from 'react';

import { createCustomObjectConfigurationMachine } from './machine';
import { ObjectConfigurationContext, Send, State } from './types';
import { useCustomObjects } from './useCustomObjects';

function useStateMachineInternal() {
  const context: ObjectConfigurationContext = {};

  const machine = useMemo(() => {
    return createCustomObjectConfigurationMachine(context);
  }, []);

  return useMachine(machine);
}

type Machine = [State, Send];
export function useStateMachine(): Machine {
  const client = useCustomObjects();

  const [state, send] = useStateMachineInternal();

  useEffect(() => {
    send({ type: 'INIT', client });
  }, [client]);

  return [state, send];
}
